import { render, staticRenderFns } from "./GeradorRelatorios.vue?vue&type=template&id=24ac1144&scoped=true&"
import script from "./GeradorRelatorios.vue?vue&type=script&lang=js&"
export * from "./GeradorRelatorios.vue?vue&type=script&lang=js&"
import style0 from "./GeradorRelatorios.vue?vue&type=style&index=0&id=24ac1144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac1144",
  null
  
)

export default component.exports